export interface AutocompletePrediction {
  description: string
  place_id: string
  structured_formatting: {
    main_text: string
    secondary_text: string
  }
  distance_meters?: number
}

export const initAutocomplete = async (
  input: string,
  updateState: any,
  countryCode?: string,
) => {
  if (typeof window !== 'undefined' && window.google?.maps?.places) {
    if (typeof window['googleAutocompleteSessionToken'] === 'undefined') {
      window[
        'googleAutocompleteSessionToken'
      ] = new window.google.maps.places.AutocompleteSessionToken()
    }

    const options: google.maps.places.AutocompleteRequest = {
      input,
      sessionToken: window['googleAutocompleteSessionToken'],
    }

    if (countryCode) {
      options.includedRegionCodes = [countryCode]
    }

    try {
      const {
        suggestions,
      } = await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
        options,
      )

      const predictions: AutocompletePrediction[] = []
      suggestions.forEach((suggestion) => {
        const placePrediction = suggestion.placePrediction
        const prediction: AutocompletePrediction = {
          description: placePrediction?.text.text || '',
          place_id: placePrediction?.placeId || '',
          structured_formatting: {
            main_text: placePrediction?.mainText?.text || '',
            secondary_text: placePrediction?.secondaryText?.text || '',
          },
          distance_meters: placePrediction?.distanceMeters || undefined,
        }
        predictions.push(prediction)
      })
      updateState(predictions)
    } catch (error) {
      console.error('Failed to search places', error)
    }
  }
}
